import { fork } from "redux-saga/effects";
import watchPermissions from "./components/permission/sagas";
import watchUserGroups from "./components/usergroup/sagas";

const WatchAuthentication = [fork(watchPermissions), fork(watchUserGroups)]
export {
  WatchAuthentication
}